import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const AudioOffFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.3 8.26C7.06 8.26 7.44 8.12 8.02 7.64L12.96 3.52V20.4L8.04 16.3C7.42 15.8 7.08 15.68 6.3 15.68H2.3V8.26H6.3Z" />
    </SvgIcon>
  );
});
